import { render, staticRenderFns } from "./Evaluation.vue?vue&type=template&id=7704f3c6&"
import script from "./Evaluation.vue?vue&type=script&lang=js&"
export * from "./Evaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend-internal/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BButton, BCol, BRow, BContainer} from 'bootstrap-vue'
    installComponents(component, {BButton, BCol, BRow, BContainer})
    

export default component.exports